import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { PatternFormat } from 'react-number-format';
import { useTheme } from '../../../contexts/ThemeContext';

const CepInput = ({
  value,
  onChange,
  placeholder = '00000-000',
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <PatternFormat
      format="#####-###"
      mask="_"
      value={value}
      onValueChange={(values) => {
        if (onChange) {
          onChange(values.value);
        }
      }}
      customInput={Input}
      placeholder={placeholder}
      style={{
        backgroundColor: theme.backgroundSecondary,
        color: theme.textSecondary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

CepInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CepInput; 